import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ForgeModule } from "@tylertech/forge-angular";
import { LgdDatePickerComponent } from "./lgdDatePicker.component";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ForgeModule],
    declarations: [LgdDatePickerComponent],
    exports: [
        ReactiveFormsModule,
        LgdDatePickerComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdDatePickerModule { }
